import { chain } from 'underscore';
import { AccountLabelMccReport } from '@bingads-webui-campaign/campaign-ui-schemas';

/* global Map */
export function getToolbarConfig({
  scope, reportType,
}) {
  const isLabelsAccountPage = reportType === AccountLabelMccReport.name;
  return {
    toolbarSelectedConfig: new Map(),
    toolbarUnselectedConfig: chain([
      ['predicate-list', {
        id: 'predicate-list',
        type: 'custom',
      }],
      ['expander', {
        type: 'expander',
      }],
      // only show account selector button when aid is not in scope
      (!scope.values.aid && !isLabelsAccountPage) && ['account-selector-toolbar-item', {
        id: 'account-selector-toolbar-item',
        type: 'custom',
      }],
      ['dropdown-column-chooser', {
        id: 'dropdown-column-chooser',
        type: 'dropdown',
      }],
      (scope.values.aid || isLabelsAccountPage) && ['button-download', {
        id: 'button-download',
        type: 'nav-item',
        iconLeftGlyphName: 'ba-Download',
      }],
      (!scope.values.aid && !isLabelsAccountPage) && ['multiaccount-download-toolbar-item', {
        id: 'multiaccount-download-toolbar-item',
        type: 'custom',
      }],
    ]).compact().reduce(
      (map, [key, value]) => {
        map.set(key, value);
        return map;
      },
      new Map()
    ).value(),
  };
}
